import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7ba7e217"
import script from "./App.ts?vue&type=script&lang=js&external"
export * from "./App.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports